import { setAuthorizationHeader } from 'services/authHeaders/authHeaders';
import accessTokenStorage from 'storages/accessTokenStorage';
import refreshTokenStorage from 'storages/refreshTokenStorage';

const updateAuthTokens = ({ refresh, access }: { refresh: string; access: string }) => {
  setAuthorizationHeader(access);
  refreshTokenStorage.set(refresh);
  accessTokenStorage.set(access);
};

export default updateAuthTokens;
